import React from 'react';
import {
  Button,
  Box,
  Divider,
  Stack,
  useWindowProperties,
  Body,
  Link,
} from '@qred/components-library';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { ApiStatus } from '~/store/types/sharedTypes';
import { RootState } from '~/store';
import { CountryCode } from '~/enums';
import {
  openQredCardBusinessTermsPage,
  openQredCardGeneralTermsPage,
  openQredCardPricesPage,
} from '~/services/links';
import { sendSignersCardOfferData } from '~/store/actions/additionalSignerActions';

export const CardAdditionalSignerFooter = () => {
  const dispatch = useAppDispatch();

  const {
    intl: { market, language },
    additionalSigner: {
      apiStatus: { postAdditionalSignerCardApplication },
    },
  } = useSelector((state: RootState) => state);
  const translate = useTranslate();
  const { isMobile } = useWindowProperties();

  const onConfirmClick = () => {
    dispatch(sendSignersCardOfferData());
  };

  return (
    <Box>
      <Divider thickness={1} color="neutral.16" />
      <Stack spacing={'md'} align="center" p={isMobile ? 'md' : 'xxl'}>
        <Body size="sm">
          {translate('CreditCardTermsAndConditionsCard.Text3', {
            ...(market === CountryCode.SE && {
              businessTermsLink: (
                <Link
                  size="sm"
                  onClick={() =>
                    openQredCardBusinessTermsPage(market, language)
                  }
                >
                  {translate(
                    'CreditCardTermsAndConditionsCard.Link3'
                  ).toString()}
                </Link>
              ),
            }),
            generalTermLink: (
              <Link
                size="sm"
                onClick={() => openQredCardGeneralTermsPage(market, language)}
              >
                {translate('CreditCardTermsAndConditionsCard.Link1').toString()}
              </Link>
            ),
            qredCardPricesLink: (
              <Link
                size="sm"
                onClick={() => openQredCardPricesPage(market, language)}
              >
                {translate(
                  'CreditCardTermsAndConditionsCard.Link2Legacy'
                ).toString()}
              </Link>
            ),
          })}
        </Body>
        <Button
          fullWidth={isMobile}
          onClick={onConfirmClick}
          size="md"
          isLoading={postAdditionalSignerCardApplication === ApiStatus.Started}
        >
          {translate('ConfirmTermsCard.ConfirmAgreement')}
        </Button>
      </Stack>
    </Box>
  );
};
